export const ACCESS_TOKEN = "access_token";
export const REFRESH_TOKEN = "refresh";
export const AUTHENTICATED_USER = "authenticated_user";
export const TOKEN_EXPIRED = "token_not_valid";
export const CACHE_KEY_USER_INFO = 'userInfoCache';
export const CACHE_KEY_PERMISSIONS = 'userPermissionsCache';
